import { Link, Table } from '@watcherr/ui';
import * as React from 'react';
import { t } from '~/i18n';

const PermissionTable = ({ permissions }) => (
  <Table>
    <Table.Head>
      <Table.Row>
        <Table.HeadCol>{t('permissions.table.permission')}</Table.HeadCol>
        <Table.HeadCol>{t('permissions.table.access')}</Table.HeadCol>
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {permissions.map((permission) => (
        <Table.Row key={`permissions-table-row-${permission.id}`}>
          <Table.Col style={{ width: 'auto' }}>{permission.name}</Table.Col>
          <Table.Col style={{ width: 90 }}>
            <Link className="btn-link" href={`/authority-levels/${permission.id}`}>
              {t('permissions.table.editAccess')}
            </Link>
          </Table.Col>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);
export default PermissionTable;
